import React from "react";
import LearningPlanExamSuccessPostTest from "../LearningPlans/LearningPlanExamSuccessPostTest";

export default class LearningPlanExamResultsStandalone extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.print();
  }

  render() {
    console.log("LearningPlanExamResultsStandalone", this.props);
    const {
      courses,
      learning_plan,
      user_assessment,
      personalData = {},
      testCompletedAt,
    } = this.props;
    const { data } = user_assessment;
    return (
      <LearningPlanExamSuccessPostTest
        {...data}
        learning_plan={learning_plan}
        testCompletedAt={testCompletedAt}
        personalData={personalData}
        courses={courses}
        is_admin={true}
        standalone={true}
      />
    );
  }
}
